// extracted by mini-css-extract-plugin
export default {"sectionContainer":"Products_sectionContainer__87VdJ"};